import React from 'react';
import propTypes from 'prop-types';
import mergeI18n from '../../lib/util/merge-i18n';
import i18n from './i18n';

class Privacy extends React.Component {
	componentDidMount () {
		this.props.setParentState({
			progressIndex: -1,
			canLogOut: false,
			canGoToHomePage: true
		});
	}

	render () {
		const __ = mergeI18n(this.props.language, i18n);
		document.title = `${__.titleStem} - ${__.pageTitle}`;

		return (
			<div id='lss-content' className='container'>
				<div className='row'>
					<div className='col-xs-12'>
						<div id='privacy'>
							<div className='row'>
								<div className='col-xs-12'>
									<h1>{__.pageTitle}</h1>

									<time><i>{__.updated}</i></time>

									<h2>{__.introduction.title}</h2>
									<p>{__.introduction.p1()}</p>
									<p>{__.introduction.p2}</p>
									<p>{__.introduction.p3}</p>
									<p>{__.introduction.p4}</p>

									<p>{__.contents.description}</p>
									<ul>
										<li>
											{__.contents.informationCollected.title}
											<ul>
												<li>{__.contents.informationCollected.provided.title}</li>
												<li>{__.contents.informationCollected.automated.title}</li>
												<li>{__.contents.informationCollected.dataTechnologies.title}</li>
												<li>{__.contents.informationCollected.videos.title}</li>
												<li>{__.contents.informationCollected.location.title}</li>
												<li>{__.contents.informationCollected.publiclyPosted.title}</li>
												<li>{__.contents.informationCollected.combined.title}</li>
											</ul>
										</li>
										<li>{__.contents.informationUse.title}</li>
										<li>{__.contents.applications.title}</li>
										<li>{__.contents.advertisingNetworks.title}</li>
										<li>{__.contents.informationShared.title}
											<ul>
												<li>{__.contents.informationShared.affiliates.title}</li>
												<li>{__.contents.informationShared.serviceProviders.title}</li>
												<li>{__.contents.informationShared.corporate.title}</li>
												<li>{__.contents.informationShared.databases.title}</li>
												<li>{__.contents.informationShared.other.title}</li>
											</ul>
										</li>
										<li>{__.contents.choices.title}</li>
										<li>{__.contents.dataTransfers.title}</li>
										<li>{__.contents.access.title}</li>
										<li>{__.contents.links.title}</li>
										<li>{__.contents.dataSecurity.title}</li>
										<li>{__.contents.disputes.title}</li>
										<li>{__.contents.updates.title}</li>
										<li>{__.contents.contact.title}</li>
										<li>{__.contents.californiaRights.title}</li>
									</ul>

									<h2>{__.contents.informationCollected.title}</h2>
									<p>{__.contents.informationCollected.description}</p>

									<p><strong>{__.contents.informationCollected.provided.title}.</strong> {__.contents.informationCollected.provided.description}</p>
									<ol>
										<li>{__.contents.informationCollected.provided.ol.i1}</li>
										<li>{__.contents.informationCollected.provided.ol.i2}</li>
										<li>{__.contents.informationCollected.provided.ol.i3}</li>
										<li>{__.contents.informationCollected.provided.ol.i4}</li>
										<li>{__.contents.informationCollected.provided.ol.i5}</li>
									</ol>

									<p><strong>{__.contents.informationCollected.automated.title}.</strong> {__.contents.informationCollected.automated.description}</p>
									<ol>
										<li>{__.contents.informationCollected.automated.ol.i1}</li>
										<li>{__.contents.informationCollected.automated.ol.i2}</li>
										<li>{__.contents.informationCollected.automated.ol.i3}</li>
										<li>{__.contents.informationCollected.automated.ol.i4}</li>
									</ol>

									<p><strong>{__.contents.informationCollected.dataTechnologies.title}.</strong> {__.contents.informationCollected.dataTechnologies.p1}</p>
									<p>{__.contents.informationCollected.dataTechnologies.p2}</p>
									<p>{__.contents.informationCollected.dataTechnologies.p3}</p>

									<p><strong>{__.contents.informationCollected.videos.title}.</strong> {__.contents.informationCollected.videos.description}</p>

									<p><strong>{__.contents.informationCollected.location.title}.</strong> {__.contents.informationCollected.location.description}</p>

									<p><strong>{__.contents.informationCollected.publiclyPosted.title}.</strong> {__.contents.informationCollected.publiclyPosted.description}</p>

									<p><strong>{__.contents.informationCollected.combined.title}.</strong> {__.contents.informationCollected.combined.description}</p>

									<h2>{__.contents.informationUse.title}</h2>
									<p>{__.contents.informationUse.description}</p>
									<ol>
										<li>{__.contents.informationUse.ol.i1}</li>
										<li>{__.contents.informationUse.ol.i2}</li>
										<li>{__.contents.informationUse.ol.i3}</li>
										<li>{__.contents.informationUse.ol.i4}</li>
										<li>{__.contents.informationUse.ol.i5}</li>
										<li>{__.contents.informationUse.ol.i6}</li>
										<li>{__.contents.informationUse.ol.i7}</li>
										<li>{__.contents.informationUse.ol.i8}</li>
										<li>{__.contents.informationUse.ol.i9}</li>
										<li>{__.contents.informationUse.ol.i10}</li>
									</ol>

									<h2>{__.contents.applications.title}</h2>
									<p>{__.contents.applications.description}</p>

									<h2>{__.contents.advertisingNetworks.title}</h2>
									<p>{__.contents.advertisingNetworks.p1}</p>
									<p>{__.contents.advertisingNetworks.p2}</p>
									<p>{__.contents.advertisingNetworks.p3()}</p>

									<h2>{__.contents.informationShared.title}</h2>
									<p>{__.contents.informationShared.description}</p>

									<p><strong>{__.contents.informationShared.affiliates.title}.</strong> {__.contents.informationShared.affiliates.description()}</p>

									<p><strong>{__.contents.informationShared.serviceProviders.title}.</strong> {__.contents.informationShared.serviceProviders.description}</p>

									<p><strong>{__.contents.informationShared.corporate.title}.</strong> {__.contents.informationShared.corporate.description}</p>

									<p><strong>{__.contents.informationShared.databases.title}.</strong> {__.contents.informationShared.databases.description}</p>

									<p><strong>{__.contents.informationShared.other.title}.</strong> {__.contents.informationShared.other.description}</p>
									<ol>
										<li>{__.contents.informationShared.other.ol.i1}</li>
										<li>{__.contents.informationShared.other.ol.i2}</li>
										<li>{__.contents.informationShared.other.ol.i3}</li>
										<li>{__.contents.informationShared.other.ol.i4}</li>
									</ol>

									<h2>{__.contents.choices.title}</h2>
									<p>{__.contents.choices.description}</p>
									<ol>
										<li>{__.contents.choices.ol.i1}</li>
										<li>{__.contents.choices.ol.i2}</li>
										<li>{__.contents.choices.ol.i3}</li>
										<li>{__.contents.choices.ol.i4}</li>
										<li>{__.contents.choices.ol.i5}</li>
									</ol>

									<h2>{__.contents.dataTransfers.title}</h2>
									<p>{__.contents.dataTransfers.description}</p>

									<h2>{__.contents.access.title}</h2>
									<p>{__.contents.access.description}</p>

									<h2>{__.contents.links.title}</h2>
									<p>{__.contents.links.description}</p>

									<h2>{__.contents.dataSecurity.title}</h2>
									<p>{__.contents.dataSecurity.description}</p>

									<h2>{__.contents.disputes.title}</h2>
									<p>{__.contents.disputes.description}</p>

									<h2>{__.contents.updates.title}</h2>
									<p>{__.contents.updates.description}</p>

									<h2>{__.contents.contact.title}</h2>
									<p>{__.contents.contact.description()}</p>

									<h2>{__.contents.californiaRights.title}</h2>
									<p>{__.contents.californiaRights.p1()}</p>
									<p>{__.contents.californiaRights.p2()}</p>

									<h3>{__.contents.californiaRights.collect.title}</h3>
									<p>{__.contents.californiaRights.collect.p1()}</p>
									<ul>
										<li>{__.contents.californiaRights.collect.ul1.i1}</li>
										<li>{__.contents.californiaRights.collect.ul1.i2}</li>
										<li>{__.contents.californiaRights.collect.ul1.i3}</li>
									</ul>
									<p>{__.contents.californiaRights.collect.p2}</p>
									<table>
										<thead>
											<tr>
												<th className='category-column'>Category</th>
												<th className='examples-column'>Examples</th>
												<th>Collected</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td>{__.contents.californiaRights.collect.table.identifiers.category}</td>
												<td>{__.contents.californiaRights.collect.table.identifiers.examples}</td>
												<td>{__.contents.californiaRights.collect.table.identifiers.collected}</td>
											</tr>
											<tr>
												<td rowSpan={2}>{__.contents.californiaRights.collect.table.personal.category()}</td>
												<td>{__.contents.californiaRights.collect.table.personal.examples1}</td>
												<td>{__.contents.californiaRights.collect.table.personal.collected1}</td>
											</tr>
											<tr>
												<td>{__.contents.californiaRights.collect.table.personal.examples2}</td>
												<td>{__.contents.californiaRights.collect.table.personal.collected2}</td>
											</tr>
											<tr>
												<td>{__.contents.californiaRights.collect.table.protected.category}</td>
												<td>{__.contents.californiaRights.collect.table.protected.examples}</td>
												<td>{__.contents.californiaRights.collect.table.protected.collected}</td>
											</tr>
											<tr>
												<td>{__.contents.californiaRights.collect.table.commercial.category}</td>
												<td>{__.contents.californiaRights.collect.table.commercial.examples}</td>
												<td>{__.contents.californiaRights.collect.table.commercial.collected}</td>
											</tr>
											<tr>
												<td>{__.contents.californiaRights.collect.table.biometric.category}</td>
												<td>{__.contents.californiaRights.collect.table.biometric.examples}</td>
												<td>{__.contents.californiaRights.collect.table.biometric.collected}</td>
											</tr>
											<tr>
												<td>{__.contents.californiaRights.collect.table.internet.category}</td>
												<td>{__.contents.californiaRights.collect.table.internet.examples}</td>
												<td>{__.contents.californiaRights.collect.table.internet.collected}</td>
											</tr>
											<tr>
												<td>{__.contents.californiaRights.collect.table.geolocation.category}</td>
												<td>{__.contents.californiaRights.collect.table.geolocation.examples}</td>
												<td>{__.contents.californiaRights.collect.table.geolocation.collected}</td>
											</tr>
											<tr>
												<td>{__.contents.californiaRights.collect.table.sensory.category}</td>
												<td>{__.contents.californiaRights.collect.table.sensory.examples}</td>
												<td>{__.contents.californiaRights.collect.table.sensory.collected}</td>
											</tr>
											<tr>
												<td>{__.contents.californiaRights.collect.table.professional.category}</td>
												<td>{__.contents.californiaRights.collect.table.professional.examples}</td>
												<td>{__.contents.californiaRights.collect.table.professional.collected}</td>
											</tr>
											<tr>
												<td>{__.contents.californiaRights.collect.table.education.category}</td>
												<td>{__.contents.californiaRights.collect.table.education.examples}</td>
												<td>{__.contents.californiaRights.collect.table.education.collected}</td>
											</tr>
											<tr>
												<td>{__.contents.californiaRights.collect.table.inferences.category}</td>
												<td>{__.contents.californiaRights.collect.table.inferences.examples}</td>
												<td>{__.contents.californiaRights.collect.table.inferences.collected}</td>
											</tr>
										</tbody>
									</table>
									<p>{__.contents.californiaRights.collect.p3}</p>
									<ul>
										<li>{__.contents.californiaRights.collect.ul2.i1}</li>
										<li>{__.contents.californiaRights.collect.ul2.i2}</li>
										<li>{__.contents.californiaRights.collect.ul2.i3()}</li>
										<li>{__.contents.californiaRights.collect.ul2.i4}</li>
									</ul>

									<h3>{__.contents.californiaRights.use.title}</h3>
									<p>{__.contents.californiaRights.use.p1}</p>
									<ul>
										<li>{__.contents.californiaRights.use.ul.i1}</li>
										<li>{__.contents.californiaRights.use.ul.i2}</li>
										<li>{__.contents.californiaRights.use.ul.i3}</li>
										<li>{__.contents.californiaRights.use.ul.i4}</li>
										<li>{__.contents.californiaRights.use.ul.i5}</li>
										<li>{__.contents.californiaRights.use.ul.i6}</li>
										<li>{__.contents.californiaRights.use.ul.i7}</li>
										<li>{__.contents.californiaRights.use.ul.i8}</li>
										<li>{__.contents.californiaRights.use.ul.i9}</li>
										<li>{__.contents.californiaRights.use.ul.i10}</li>
										<li>{__.contents.californiaRights.use.ul.i11}</li>
									</ul>
									<p>{__.contents.californiaRights.use.p2}</p>

									<h3>{__.contents.californiaRights.sharing.title}</h3>
									<p>{__.contents.californiaRights.sharing.p1}</p>
									<ul>
										<li>{__.contents.californiaRights.sharing.ul.i1}</li>
										<li>{__.contents.californiaRights.sharing.ul.i2}</li>
										<li>{__.contents.californiaRights.sharing.ul.i3}</li>
									</ul>

									<h4>{__.contents.californiaRights.sharing.disclosures.title}</h4>
									<p>{__.contents.californiaRights.sharing.disclosures.p1}</p>
									<ul>
										<li>{__.contents.californiaRights.sharing.disclosures.ul1.i1}</li>
										<li>{__.contents.californiaRights.sharing.disclosures.ul1.i2}</li>
										<li>{__.contents.californiaRights.sharing.disclosures.ul1.i3}</li>
										<li>{__.contents.californiaRights.sharing.disclosures.ul1.i4}</li>
										<li>{__.contents.californiaRights.sharing.disclosures.ul1.i5}</li>
									</ul>
									<p>{__.contents.californiaRights.sharing.disclosures.p2}</p>
									<ul>
										<li>{__.contents.californiaRights.sharing.disclosures.ul2.i1}</li>
										<li>{__.contents.californiaRights.sharing.disclosures.ul2.i2}</li>
										<li>{__.contents.californiaRights.sharing.disclosures.ul2.i3}</li>
									</ul>
									<p>{__.contents.californiaRights.sharing.disclosures.p3}</p>
									<ul>
										<li>{__.contents.californiaRights.sharing.disclosures.ul3.i1}</li>
									</ul>

									<h3>{__.contents.californiaRights.rights.title}</h3>
									<p>{__.contents.californiaRights.rights.description}</p>

									<h4>{__.contents.californiaRights.rights.access.title}</h4>
									<p>{__.contents.californiaRights.rights.access.description}</p>
									<ul>
										<li>{__.contents.californiaRights.rights.access.ul.i1}</li>
										<li>{__.contents.californiaRights.rights.access.ul.i2}</li>
										<li>{__.contents.californiaRights.rights.access.ul.i3}</li>
										<li>{__.contents.californiaRights.rights.access.ul.i4}</li>
										<li>{__.contents.californiaRights.rights.access.ul.i5}</li>
										<li>{__.contents.californiaRights.rights.access.ul.i6}</li>
										<ul>
											<li>{__.contents.californiaRights.rights.access.ul.ul.i1}</li>
											<li>{__.contents.californiaRights.rights.access.ul.ul.i2}</li>
										</ul>
									</ul>

									<h4>{__.contents.californiaRights.rights.deletion.title}</h4>
									<p>{__.contents.californiaRights.rights.deletion.description}</p>
									<p>{__.contents.californiaRights.rights.deletion.p1}</p>
									<ol>
										<li>{__.contents.californiaRights.rights.deletion.ol.i1}</li>
										<li>{__.contents.californiaRights.rights.deletion.ol.i2}</li>
										<li>{__.contents.californiaRights.rights.deletion.ol.i3}</li>
										<li>{__.contents.californiaRights.rights.deletion.ol.i4}</li>
										<li>{__.contents.californiaRights.rights.deletion.ol.i5()}</li>
										<li>{__.contents.californiaRights.rights.deletion.ol.i6}</li>
										<li>{__.contents.californiaRights.rights.deletion.ol.i7}</li>
										<li>{__.contents.californiaRights.rights.deletion.ol.i8}</li>
										<li>{__.contents.californiaRights.rights.deletion.ol.i9}</li>
									</ol>
									<p>{__.contents.californiaRights.rights.deletion.p2}</p>

									<h4>{__.contents.californiaRights.rights.exercising.title}</h4>
									<p>{__.contents.californiaRights.rights.exercising.p1}</p>
									<ul>
										<li>{__.contents.californiaRights.rights.exercising.ul1.i1}</li>
										<li>{__.contents.californiaRights.rights.exercising.ul1.i2()}</li>
									</ul>
									<p>{__.contents.californiaRights.rights.exercising.p2}</p>
									<p>{__.contents.californiaRights.rights.exercising.p3}</p>
									<ul>
										<li>{__.contents.californiaRights.rights.exercising.ul2.i1}</li>
										<li>{__.contents.californiaRights.rights.exercising.ul2.i2}</li>
										<li>{__.contents.californiaRights.rights.exercising.ul2.i3}</li>
									</ul>
									<p>{__.contents.californiaRights.rights.exercising.p4}</p>
									<p>{__.contents.californiaRights.rights.exercising.p5}</p>
									<p>{__.contents.californiaRights.rights.exercising.p6}</p>

									<h4>{__.contents.californiaRights.rights.response.title}</h4>
									<p>{__.contents.californiaRights.rights.response.p1}</p>
									<p>{__.contents.californiaRights.rights.response.p2}</p>
									<p>{__.contents.californiaRights.rights.response.p3}</p>
									<p>{__.contents.californiaRights.rights.response.p4}</p>

									<h3>{__.contents.californiaRights.nonDiscrimination.title}</h3>
									<p>{__.contents.californiaRights.nonDiscrimination.p1}</p>
									<ul>
										<li>{__.contents.californiaRights.nonDiscrimination.ul.i1}</li>
										<li>{__.contents.californiaRights.nonDiscrimination.ul.i2}</li>
										<li>{__.contents.californiaRights.nonDiscrimination.ul.i3}</li>
										<li>{__.contents.californiaRights.nonDiscrimination.ul.i4}</li>
									</ul>
									<p>{__.contents.californiaRights.nonDiscrimination.p2}</p>

									<h3>{__.contents.californiaRights.other.title}</h3>
									<p>{__.contents.californiaRights.other.description()}</p>

									<h3>{__.contents.californiaRights.changes.title}</h3>
									<p>{__.contents.californiaRights.changes.description()}</p>

									<h3>{__.contents.californiaRights.contact.title}</h3>
									<p>{__.contents.californiaRights.contact.description()}</p>
									<ul className='contact-info'>
										<li>{__.contents.californiaRights.contact.ul.i1()}</li>
										<li>{__.contents.californiaRights.contact.ul.i2()}</li>
										<li>{__.contents.californiaRights.contact.ul.i3()}</li>
										<li>{__.contents.californiaRights.contact.ul.i4()}</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

Privacy.propTypes = {
	language: propTypes.string.isRequired
};
export default Privacy;
